import { createUnifiedTheme, palettes } from '@backstage/theme';

export const slateTheme = createUnifiedTheme({
  palette: {
    ...palettes.light,
    primary: {
      main: '#0EA5E9',
      light: '#38BDF8',
      dark: '#0284C7',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#10B981',
      light: '#34D399',
      dark: '#059669',
      contrastText: '#FFFFFF',
    },
    navigation: {
      background: '#0F172A',
      indicator: '#0EA5E9',
      color: '#94A3B8',
      selectedColor: '#F1F5F9',
      navItem: {
        hoverBackground: '#1E293B',
      },
      submenu: {
        background: '#1E293B',
      },
    },
    background: {
      default: '#F8FAFC',
      paper: '#FFFFFF',
    },
    text: {
      primary: '#1E293B',
      secondary: '#475569',
      disabled: '#94A3B8',
      hint: '#94A3B8',
    },
  },
  components: {
    BackstageHeader: {
      styleOverrides: {
        header: {
          backgroundImage: 'linear-gradient(90deg, #0F172A 0%, #0284C7 100%)',
          boxShadow: 'none',
        },
        title: {
          color: '#FFFFFF',
        },
        subtitle: {
          color: '#94A3B8',
        },
        type: {
          color: '#38BDF8',
        },
      },
    },
  },
});
